import * as fromDatatype from "../datatype-library/index";

export interface bl_inv_stock_level_monitoring_event_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.IntegerDatatypeInterface;
  group_guid_01: fromDatatype.GuidDataFieldInterface;
  group_guid_02: fromDatatype.GuidDataFieldInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  rrule: fromDatatype.VrsnDataFieldInterface;

  // standard fields
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_inv_stock_level_monitoring_event_hdr_RowClass
  implements bl_inv_stock_level_monitoring_event_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  run_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  duration_day: fromDatatype.IntegerDatatypeInterface;
  group_guid_01: fromDatatype.GuidDataFieldInterface;
  group_guid_02: fromDatatype.GuidDataFieldInterface;
  recurring_event_params: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  rrule: fromDatatype.VrsnDataFieldInterface;

  // standard fields
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

enum VisibilityEnum {
  DEFAULT,
  PRIVATE,
  PUBLIC,
}

enum RecurringUpdateEnum {
  THIS_EVENT,
  THIS_AND_FOLLOWING_EVENTS,
  ALL_EVENTS,
}
